import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFoul = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.90566 5.38051C1.38496 4.85981 1.38496 4.01559 1.90566 3.49489L3.79128 1.60927C4.31198 1.08858 5.1562 1.08858 5.6769 1.60927L14.1622 10.0946C14.6829 10.6153 14.6829 11.4595 14.1622 11.9802L12.2766 13.8658C11.7559 14.3865 10.9116 14.3865 10.3909 13.8658L1.90566 5.38051Z",
			fill: "#006689"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.1616 3.49515C14.6823 4.01585 14.6827 4.86053 14.162 5.38123L5.67675 13.8665C5.15605 14.3872 4.31137 14.3867 3.79068 13.866L1.90506 11.9804C1.38459 11.4597 1.38444 10.6154 1.90506 10.0948L10.3903 1.60953C10.911 1.08883 11.7557 1.08929 12.2764 1.60999L14.1616 3.49515ZM7.15818 7.89938C7.1581 7.5313 6.85966 7.23286 6.49158 7.23278C6.12344 7.23278 5.82507 7.53125 5.82499 7.89938C5.82499 8.26757 6.12339 8.56597 6.49158 8.56597C6.85971 8.56589 7.15818 8.26752 7.15818 7.89938ZM8.49137 9.23257C8.49122 8.86451 8.19287 8.56597 7.82478 8.56597C7.45668 8.56597 7.15833 8.86451 7.15818 9.23257C7.15818 9.60076 7.45659 9.89916 7.82478 9.89916C8.19297 9.89916 8.49137 9.60076 8.49137 9.23257ZM8.49137 6.56618C8.49137 6.198 8.19297 5.89959 7.82478 5.89959C7.45659 5.89959 7.15818 6.198 7.15818 6.56618C7.15818 6.93437 7.45659 7.23278 7.82478 7.23278C8.19297 7.23278 8.49137 6.93437 8.49137 6.56618ZM9.82456 7.89938C9.82448 7.53125 9.52611 7.23278 9.15797 7.23278C8.78989 7.23286 8.49145 7.5313 8.49137 7.89938C8.49137 8.26752 8.78984 8.56589 9.15797 8.56597C9.52616 8.56597 9.82456 8.26757 9.82456 7.89938Z",
			fill: "#01ADE8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3909 1.60927C10.9116 1.08858 11.7559 1.08858 12.2766 1.60927L14.1622 3.49489C14.6829 4.01559 14.6829 4.85981 14.1622 5.38051L13.5429 5.9998C13.5429 5.9998 12.0778 3.7176 10.6668 3.9998C7.33343 4.66647 1.92529 11.9998 1.92529 11.9998L1.90566 11.9802C1.38496 11.4595 1.38496 10.6153 1.90566 10.0946L10.3909 1.60927Z",
			fill: "black",
			fillOpacity: .1
		})
	]
});
export default SvgFoul;
